import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { HorizonToastService } from '@bayclubs/horizon';

import { GroupClassDetailsModel, SetRealAttendanceApiCommand } from '@bayclubs/group-classes-employee-api';
import { TranslateService } from '@ngx-translate/core';
import { GlobalEventsService } from 'src/app/infrastructure/infrastructure.module';
import { GroupClassesApiService } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-real-attendance-save',
    templateUrl: './real-attendance-save.component.html',
    styleUrls: ['./real-attendance-save.component.scss'],
    standalone: false
})
export class RealAttendanceSaveComponent implements OnInit {
    close: Function;
    public model: GroupClassDetailsModel;
    public isLoaded = true;
    form: UntypedFormGroup;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private groupClassesApiService: GroupClassesApiService,
        private toast: HorizonToastService,
        private globalEventsService: GlobalEventsService,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            realAttendance: [this.model.realAttendance, []]
        });
    }
    public onSave() {
        const request = this.getRequest();
        this.groupClassesApiService.setRealAttendance(this.model.id, request).subscribe(x => {
            this.globalEventsService.onGroupClassUpdated$.emit({ id: this.model.id });
            this.toast.success(this.translate.instant('Utils.OperationOk'));
            this.close();
        });
    }

    protected getRequest(): SetRealAttendanceApiCommand {
        const request = <SetRealAttendanceApiCommand>{
            realAttendance: this.form.value.realAttendance
        };
        return request;
    }
    public onClose() {
        this.close();
    }

    public get isRealAttendanceEdit(): boolean {
        return this.model.realAttendance !== null;
    }
}
